import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["select"]

  static values = {
    "urlTemplate": String
  }

  visit(evt) {
    evt.preventDefault()
    const stateParam = this.selectTarget.value
    const url = this.urlTemplateValue.replace(/[\w-_]+$/, stateParam)
    window.location = url
  }
}
